export const linkLabels: { [name: string]: string } = {
  'en-us': `Read More`,
  'zh-tw': `了解更多`,
  'ja-jp': `もっと見る`,
};
